<template>
  <div class="TableDropdown">
    <template v-if="outsideMenus && outsideMenus.length">
      <el-tooltip
          v-for="item in outsideMenus"
          class="item"
          effect="dark"
          :content="item.text"
          placement="top"
      >
        <el-button
            :disabled="item.disabled"
            :icon="item.icon"
            type="primary"
            size="mini"
            circle
            @click="item.fn(...item.arguments)"
        ></el-button>
      </el-tooltip>
    </template>
    <el-dropdown v-if="dropdownMenus && dropdownMenus.length" @command="handleCommand">
      <span class="el-dropdown-link">
        更多<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in dropdownMenus" :disabled="item.disabled" :command="item">{{ item.text }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "TableDropdown",
  props: {
    menus: {
      type: Array,
      default: () => {
        return []
      }
    },
    outsideCount: {
      type: Number,
      default: 2
    },
  },
  computed: {
    currentMenus() {
      return this.menus.map(menu => {
        if (!menu.permission) {
          menu.permission = []
        }
        if (!menu.hasOwnProperty('show')) {
          menu.show = true
        }
        if (!menu.fn) {
          menu.fn = () => {}
        }
        if (!menu.arguments) {
          menu.arguments = []
        }
        return menu
      }).filter(menu => {
        if (menu.permission.length) {
          const resources = store.getters.resources;
          const curentRouterName = this.$router.history.current.name;
          let hasPermission = false;
          if (!resources || resources.length === 0) {
            hasPermission = false;
          } else {
            try {
              const childrenResources = resources.filter(res => {
                return `${res.parentId}` === `${curentRouterName}`;
              });

              if (childrenResources && childrenResources.length > 0) {
                hasPermission = childrenResources.some(res => {
                  return menu.permission.includes(res.path);
                });
              }
            } catch (e) {
              return false;
            }
          }

          if (!hasPermission) {
            return false;
          }
        }
        return menu.show;
      })
    },
    outsideMenus() {
      if (this.currentMenus && this.currentMenus.length) {
        return this.currentMenus.slice(0, this.outsideCount)
      }
      return []
    },
    dropdownMenus() {
      if (this.currentMenus && this.currentMenus.length > this.outsideCount) {
        return this.currentMenus.slice(this.outsideCount)
      }
      return []
    }
  },
  methods: {
    handleCommand(command) {
      command.fn(...command.arguments)
    }
  }
};
</script>

<style lang="scss" scoped>
.TableDropdown {
  .el-dropdown-link {
    cursor: pointer;
    color: #e93c27;
    margin-left: 10px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>
